module.exports = __webpack_public_path__ + "static/media/home-bg.afbd595e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-bg.jpg
// module id = 94
// module chunks = 0